import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import RoleAssignmentListViewModelType from '@/ViewModels/Controls/RoleAssignmentListViewModel';
import RoleAssignmentListType from '@/Controls/RoleAssignmentList';
import LabelViewModelType from '@/ViewModels/Controls/LabelViewModel';
import RoleAssignmentFactory from '@/Factories/ControlFactories/RoleAssignmentFactory';
import { IControlFactoryConstructorParameter } from '#/CoreFrameInterfaces';

export default class RoleAssignmentListFactory extends ControlFactory {

    private RoleAssignmentListViewModel = ComponentManager.getViewModel<typeof RoleAssignmentListViewModelType>('RoleAssignmentListViewModel');
    private RoleAssignmentList = ComponentManager.getControl<typeof RoleAssignmentListType>('RoleAssignmentList');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelType>('LabelViewModel');
    private jqueryControl: JQuery;

    /** 
     * @override
     */
    public viewModel: RoleAssignmentListViewModelType;

    public constructor(params: IControlFactoryConstructorParameter) {
        super(params);
    }

    // @Override
    public getControl() {
        if (this.jqueryControl != null) {
            return this.jqueryControl;
        }

        const roleAssignmentFactory = this.context.getUIFactory<RoleAssignmentFactory>('RoleAssignment');
        const roleAssignmentViewModel = roleAssignmentFactory.viewModel;

        this.viewModel = new this.RoleAssignmentListViewModel({
            factory: this,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            isRequired: this.isRequired,
            name: this.detailViewItem.name,
            isEnabled: roleAssignmentFactory.isEnabled,
            isDisplayed: roleAssignmentViewModel.isDisplayed,
            values: roleAssignmentViewModel.values,
            redraw: roleAssignmentViewModel.onTabChange,
            PrincipalsAndUserGroupsDTO: roleAssignmentViewModel.PrincipalsAndUserGroupsDTO,
            parentLocator: roleAssignmentFactory.locator,
            locator: this.detailViewItem.name,
            roleAssignmentViewModel: roleAssignmentViewModel
        });

        this.control = new this.RoleAssignmentList(this.viewModel);

        const tuple = this.control.getTuple();
        this.jqueryControl = tuple.control;

        return this.jqueryControl;
    }
}

ComponentManager.setFactory('RoleAssignmentList', RoleAssignmentListFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');